import { Ability, AbilityBuilder } from "@casl/ability";

export const defineAbilityForPermissions = (permissions = []) => {
  const {
    can,
    /**
     * @type Array
     */
    rules,
  } = new AbilityBuilder();
  permissions.forEach((item) => {
    can(item);
  });
  return new Ability(rules);
};

export const defineRulesForPermissions = (permissions = []) => {
  const { can, rules } = new AbilityBuilder();
  permissions.forEach((item) => {
    can(item);
  });
  return rules;
};
